const PRODUCTION_APP_ORIGIN = 'https://kodeo.app';

function isLocalHostname(hostname) {
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';
}

export function getAppOrigin() {
    if (typeof window !== 'undefined') {
        const currentUrl = new URL(window.location.href);
        if (isLocalHostname(currentUrl.hostname)) {
            return currentUrl.origin;
        }
    }

    return process.env.REACT_APP_SITE_URL || PRODUCTION_APP_ORIGIN;
}

export function buildAppUrl(pathname) {
    return new URL(pathname, getAppOrigin()).toString();
}
